import {
  getOnboardingStepDef,
  ONBOARDING_SOURCE_OPTIONS,
  ONBOARDING_STEPS,
} from "../../config/onboardingWizard.js";

export default function OnboardingWizardPanel({
  step,
  answers = {},
  groupsText = "",
  onGroupsTextChange,
  onSelectSource,
  onContinueFromStep2,
  onSubmitPlan,
  onExit,
  disabled = false,
  thinking = false,
}) {
  const def = getOnboardingStepDef(step);
  const busy = disabled || thinking;
  const blockActions = busy;

  return (
    <div className="mr-4 rounded-xl border border-[rgb(var(--idaxis-accent-primary-rgb)/0.25)] bg-[rgb(var(--idaxis-accent-primary-rgb)/0.06)] px-4 py-4">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-widest text-[rgb(var(--idaxis-accent-primary-rgb)/0.9)]">Automate onboarding</p>
          <p className="mt-1 text-sm font-semibold text-slate-100">Guided wizard · Step {step} of {ONBOARDING_STEPS.length}</p>
          {def?.title ? (
            <p className="mt-0.5 text-[11px] font-medium text-slate-400">{def.title}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onExit}
          disabled={busy}
          className="shrink-0 rounded-lg border border-white/10 px-2 py-1 text-[10px] font-medium text-slate-400 hover:bg-white/[0.06] disabled:opacity-40"
        >
          Exit
        </button>
      </div>

      {def?.prompt ? (
        <p className="mt-3 text-[13px] leading-relaxed text-slate-200">{def.prompt}</p>
      ) : null}

      {step === 1 ? (
        <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3">
          {ONBOARDING_SOURCE_OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              disabled={blockActions}
              onClick={() => onSelectSource?.(opt.value, opt)}
              className="flex flex-col items-start rounded-xl border border-[rgb(var(--idaxis-accent-primary-rgb)/0.2)] bg-gradient-to-br from-[rgb(var(--idaxis-accent-primary-rgb)/0.08)] to-transparent px-3 py-3 text-left transition hover:border-[rgb(var(--idaxis-accent-primary-rgb)/0.4)] disabled:cursor-not-allowed disabled:opacity-40"
            >
              <span className="text-sm font-semibold text-slate-100">{opt.label}</span>
              {opt.description ? (
                <span className="mt-1 text-[11px] leading-snug text-slate-500">{opt.description}</span>
              ) : null}
            </button>
          ))}
        </div>
      ) : null}

      {step === 2 ? (
        <div className="mt-4 space-y-3">
          <textarea
            value={groupsText}
            onChange={(e) => onGroupsTextChange?.(e.target.value)}
            placeholder={def?.placeholder}
            disabled={busy}
            rows={def?.minRows ?? 5}
            className="w-full rounded-lg border border-white/[0.1] bg-[rgb(var(--idaxis-bg-primary-rgb)/0.55)] px-3 py-2.5 text-[13px] text-slate-200 placeholder:text-slate-600 focus:border-[rgb(var(--idaxis-accent-primary-rgb)/0.4)] focus:outline-none focus:ring-1 focus:ring-[rgb(var(--idaxis-accent-primary-rgb)/0.3)] disabled:opacity-50"
          />
          <button
            type="button"
            onClick={onContinueFromStep2}
            disabled={blockActions}
            className="rounded-lg bg-[rgb(var(--idaxis-accent-primary-rgb)/1)] px-4 py-2 text-sm font-semibold text-[var(--idaxis-bg-primary)] disabled:opacity-40"
          >
            Continue
          </button>
        </div>
      ) : null}

      {step === 3 ? (
        <div className="mt-4 space-y-4">
          <ul className="space-y-3">
            {(def?.recommendations || []).map((r) => (
              <li key={r.title} className="rounded-lg border border-white/[0.06] bg-black/20 px-3 py-2.5">
                <p className="text-[12px] font-semibold text-slate-200">{r.title}</p>
                <p className="mt-1 text-[12px] leading-relaxed text-slate-400">{r.body}</p>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={onSubmitPlan}
            disabled={blockActions}
            className="w-full rounded-lg bg-[rgb(var(--idaxis-accent-primary-rgb)/1)] py-2.5 text-sm font-bold text-[var(--idaxis-bg-primary)] shadow-[0_0_16px_rgb(var(--idaxis-accent-primary-rgb)/0.25)] disabled:opacity-40"
          >
            Submit full plan
          </button>
        </div>
      ) : null}
    </div>
  );
}
